import React from 'react';
import useReveal from '../hooks/useReveal';
import './Traction.css';

const STATS = [
  { value: '10', label: 'Mushroom institutes', desc: 'Collaborated on pilot programs' },
  { value: '100+', label: 'Aspiring farmers', desc: 'Groundwork validation & pre-production' },
  // { value: '2', label: 'Industry partners', desc: 'Impensus Electronics & Vasthak Pvt. Ltd.' },
];

export default function Traction() {
  const ref = useReveal();
  const statRef = useReveal();
  return (
    <section className="section traction" id="traction">
      <div className="container">
        <div className="reveal" ref={ref}>
          <p className="eyebrow">Traction & validation</p>
          <h2 className="section-heading">Early signal from the people who'd actually use it.</h2>
        </div>

        <div className="traction__stats reveal-stagger" ref={statRef}>
          {STATS.map((s) => (
            <div className="traction__stat" key={s.label}>
              <strong>{s.value}</strong>
              <span>{s.label}</span>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>

        <blockquote className="traction__quote reveal" ref={useReveal()}>
          <p>
            "Validated by a mushroom scientist with over 50 years of field experience — Dr. Mohan
            — as a genuinely useful practice tool ahead of real cultivation."
          </p>
          <cite>Dr. Mohan, Mushroom Cultivation Scientist</cite>
        </blockquote>
      </div>
    </section>
  );
}
